import React, {useState} from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  OutlinedInput,
  Typography,
  Box,
} from '@mui/material';
import {DialogClose} from './DialogFrame/DialogClose';

type Props = {
  name: string | React.ReactNode; // Name of the resource that going to be delete
  isPermanent?: boolean;
  onDelete: () => void;
  onCancel: () => void;
  customComponent?: React.ReactNode;
  requireTypedConfirmation?: boolean;
  confirmationText?: string;
};

const DialogConfirmDeletion = ({
  name,
  isPermanent,
  onDelete,
  onCancel,
  customComponent,
  requireTypedConfirmation = true,
  confirmationText,
}: Props) => {
  const [text, setText] = useState('');
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setText(e.target.value);
  };
  return (
    <Dialog maxWidth='md' fullWidth open PaperProps={{ sx: { zIndex: 3 } }}>
      <DialogTitle
        sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        <Typography sx={{ textAlign: 'center', width: '100%' }}>
          Delete
        </Typography>
        <Box sx={{ right: 8, top: 8 }}>
          <DialogClose onClose={onCancel} />
        </Box>
      </DialogTitle>
      <DialogContent>
        <Box
          sx={{
            p: 2,
          }}>
          {customComponent ? (
            customComponent
          ) : isPermanent ? (
            <>
              <Typography
                aria-level={2}
                variant='h6'
                sx={{
                  textAlign: 'center',
                  fontWeight: 600,
                  mb: 2,
                }}>
                Permanently Delete
              </Typography>

              <Typography>
                <strong>{name}</strong>
              </Typography>

              <Typography>You can't undo this action.</Typography>
            </>
          ) : (
            <>
            </>
          )}
          {isPermanent && (
            <Box>
              <Typography paragraph variant='body1' pt={2}>
                To avoid accidental deletion provide additional written consent.
              </Typography>
            </Box>
          )}
          {requireTypedConfirmation ? (
            <>
              <Typography paragraph variant='body2' sx={{ opacity: 0.7 }}>
                {`To confirm deletion, type "DELETE" into the field.`}
              </Typography>
              <OutlinedInput
                autoFocus
                fullWidth
                value={text}
                onChange={handleChange}
                inputProps={{ 'aria-label': 'Confirm deletion by typing delete' }}
              />
            </>
          ) : (
            <Typography paragraph variant='h6' sx={{ opacity: 0.7 }} className='text-center'>
              {confirmationText ?? 'Are you sure you want to delete this item?'}
            </Typography>
          )}
        </Box>
      </DialogContent>
      <DialogActions>
        <Button
          color='primary'
          variant='contained'
          disabled={requireTypedConfirmation && text.trim().toLowerCase() !== 'delete'}
          onClick={onDelete}>
          Delete
        </Button>
        <Button color='primary' variant='contained' onClick={onCancel}>
          Cancel
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DialogConfirmDeletion;
